<template>
  <div class="channel-table">
    <div class="data-type-tab">
      <el-tabs v-model="activeName">
        <el-tab-pane label="全部数据" name="1">全部数据</el-tab-pane>
        <el-tab-pane label="KPI" name="2">KPI</el-tab-pane>
      </el-tabs>
    </div>
    <el-table
      v-show="activeName == 1"
      :data="dataInfo"
      border
      stripe
      max-height="800"
      :header-cell-style="{
        background: '#4c84ff',
        color: '#fff',
        height: '60px',
        textAlign: 'center'
      }"
    >
      <el-table-column
        prop="name"
        label="姓名"
        align="center"
        fixed
        width="180"
      />
      <el-table-column label="带班">
        <el-table-column
          prop="total_reading_num_daily"
          label="日均在读人数（含体验）"
          align="center"
          fixed
          sortable
          width="130"
        />
        <el-table-column
          prop="G16_daily"
          label="日均在读人数（不含体验）"
          sortable
          align="center"
          fixed
          width="130"
        />
        <el-table-column
          prop="total_child_num_daily"
          label="日均总学员人数"
          sortable
          align="center"
          fixed
          width="130"
        />
        <el-table-column
          prop="formal_child_num_daily"
          label="日均正式学员人数"
          sortable
          align="center"
          fixed
          width="130"
        />
        <el-table-column
          prop="get_school_num_daily"
          label="日均到校人数"
          sortable
          align="center"
          fixed
          width="130"
        />
        <el-table-column
          prop="get_school_num_percent"
          label="日均到校率"
          sortable
          align="center"
          fixed
          width="130"
        >
          <template slot-scope="scope">
            <span>{{ `${scope.row.get_school_num_percent}%` }}</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="H1"
          label="累计日报到校人数"
          sortable
          align="center"
          fixed
          width="130"
        />
        <el-table-column
          prop="H2"
          label="累计月报到校人数"
          sortable
          align="center"
          fixed
          width="130"
        />
        <el-table-column
          prop="H3"
          label="累计体验到校人数"
          sortable
          align="center"
          fixed
          width="130"
        />
      </el-table-column>
      <el-table-column label="作业">
        <el-table-column
          prop="O1_daily"
          label="日均作业单录入量"
          sortable
          align="center"
          fixed
          width="130"
        />
        <el-table-column
          prop="O1_percent"
          label="日均作业单录入率 "
          align="center"
          sortable
          fixed
          width="130"
        >
          <template slot-scope="scope">
            <span>{{ `${scope.row.O1_percent}%` }}</span>
          </template>
        </el-table-column>
      </el-table-column>
      <el-table-column label="小结">
        <el-table-column
          prop="day_report_num_daily"
          label="日均日小结发送数"
          sortable
          align="center"
          fixed
          width="130"
        />
        <el-table-column
          prop="day_report_num_percent"
          label="日均日小结发送率"
          sortable
          align="center"
          fixed
          width="130"
        >
          <template slot-scope="scope">
            <span>{{ `${scope.row.day_report_num_percent}%` }}</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="O3_daily"
          label="日均合格日小结数"
          sortable
          align="center"
          fixed
          width="130"
        />
        <el-table-column
          prop="O3_percent"
          label="日均合格日小结率"
          sortable
          align="center"
          fixed
          width="130"
        >
          <template slot-scope="scope">
            <span>{{ `${scope.row.O3_percent}%` }}</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="N1"
          label="日小结-日报人数"
          sortable
          align="center"
          fixed
          width="130"
        />
        <el-table-column
          prop="N2"
          label="日小结-月报人数"
          sortable
          align="center"
          fixed
          width="130"
        />
        <el-table-column
          prop="N3"
          label="日小结-体验人数"
          sortable
          align="center"
          fixed
          width="130"
        />
      </el-table-column>
      <el-table-column label="续费">
        <el-table-column
          prop="F1"
          label="续费人数"
          sortable
          align="center"
          fixed
          width="130"
        />
        <el-table-column
          prop="F3"
          label="续费总额"
          sortable
          align="center"
          fixed
          width="130"
        />
        <el-table-column
          prop="A8"
          label="推荐leads数"
          sortable
          align="center"
          fixed
          width="130"
        />
        <el-table-column
          prop="C13"
          label="推荐新签人数"
          sortable
          align="center"
          fixed
          width="130"
        />
        <el-table-column
          prop="D13"
          label="推荐新签总额"
          sortable
          align="center"
          fixed
          width="130"
        />
      </el-table-column>
      <el-table-column label="退结">
        <el-table-column
          prop="refund_num"
          label="退费人次"
          sortable
          align="center"
          fixed
          width="130"
        />
        <el-table-column
          prop="lose_num"
          label="退费人数（流失）"
          sortable
          align="center"
          fixed
          width="130"
        />
        <el-table-column
          prop="refund_price"
          label="退费总额"
          sortable
          align="center"
          fixed
          width="130"
        />
        <el-table-column
          prop="K1"
          label="结课人数"
          sortable
          align="center"
          fixed
          width="130"
        />
        <el-table-column
          prop="lose_num_percent"
          label="流失率"
          sortable
          align="center"
          fixed
          width="130"
        >
          <template slot-scope="scope">
            <span>{{ `${scope.row.lose_num_percent}%` }}</span>
          </template>
        </el-table-column>
      </el-table-column>
    </el-table>
    <el-table
      v-show="activeName == 2"
      :data="dataInfo"
      border
      stripe
      max-height="800"
      :header-cell-style="{
        background: '#4c84ff',
        color: '#fff',
        height: '60px',
        textAlign: 'center'
      }"
    >
      <el-table-column
        prop="name"
        label="姓名"
        align="center"
        fixed
        width="180"
      />
      <el-table-column label="带班">
        <el-table-column
          prop="G16_daily"
          label="日均在读人数（不含体验）"
          sortable
          align="center"
          fixed
          width="130"
        />
        <el-table-column
          prop="H1"
          label="累计日报到校人数"
          sortable
          align="center"
          fixed
          width="130"
        />
        <el-table-column
          prop="H2"
          label="累计月报到校人数"
          sortable
          align="center"
          fixed
          width="130"
        />
        <el-table-column
          prop="H3"
          label="累计体验到校人数"
          sortable
          align="center"
          fixed
          width="130"
        />
      </el-table-column>
      <el-table-column label="作业">
        <el-table-column
          prop="O1_daily"
          label="日均作业单录入量"
          sortable
          align="center"
          fixed
          width="130"
        />
        <el-table-column
          prop="O1_percent"
          label="日均作业单录入率"
          sortable
          align="center"
          fixed
          width="130"
        >
          <template slot-scope="scope">
            <span>{{ `${scope.row.O1_percent}%` }}</span>
          </template>
        </el-table-column>
      </el-table-column>
      <el-table-column label="小结">
        <el-table-column
          prop="N1"
          label="日小结-日报人数"
          sortable
          align="center"
          fixed
          width="130"
        />
        <el-table-column
          prop="N2"
          label="日小结-月报人数"
          sortable
          align="center"
          fixed
          width="130"
        />
        <el-table-column
          prop="N3"
          label="日小结-体验人数"
          sortable
          align="center"
          fixed
          width="130"
        />
      </el-table-column>
      <el-table-column label="续费">
        <el-table-column
          prop="F1"
          label="续费人数"
          sortable
          align="center"
          fixed
          width="130"
        />
        <el-table-column
          prop="F3"
          label="续费总额"
          sortable
          align="center"
          fixed
          width="130"
        />
        <el-table-column
          prop="A8"
          label="推荐leads数"
          sortable
          align="center"
          fixed
          width="130"
        />
        <el-table-column
          prop="C13"
          label="推荐新签人数"
          sortable
          align="center"
          fixed
          width="130"
        />
        <el-table-column
          prop="D13"
          label="推荐新签总额"
          sortable
          align="center"
          fixed
          width="130"
        />
      </el-table-column>
      <el-table-column label="退结">
        <el-table-column
          prop="K1"
          label="结课人数"
          sortable
          align="center"
          fixed
          width="130"
        />
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
export default {
  name: 'ChannelTable',
  props: {
    dataInfo: Array
  },
  data() {
    return {
      activeName: '1'
    }
  },
  methods: {}
}
</script>

<style lang="scss" scoped>
.channel-table {
}
</style>
